import React, { Component } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "../../stylesheets/style.scss";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import "react-datepicker/dist/react-datepicker-cssmodules.css";
import { Col, Button, FormGroup, Label, Input } from "reactstrap";
import { Formik } from "formik";
import * as Yup from "yup";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCalendarAlt } from "@fortawesome/free-solid-svg-icons";
import { Department_APIs } from "./Department_APIs";
import { Resource_APIs } from "../resourcerole/Resource_APIs";
import { Ticket_Variables } from "../variables/Ticket_Variables";
import { UserConsumer } from "../../../UserContext";
import { Config, Routes } from "../../../configurations/config";
import PageLoader from "../../../components/PageLoader";
import { goBackFunction } from "../../../utils";
import FormStatus from "../../../components/FormStatus";
import CustomReactSelect from "../../../components/CustomReactSelect";
import { AlertPopups } from "../../../components/AlertPopups";
const validation = Yup.object().shape({
	DepartmentComments: Yup.string().typeError("Invalid input").max(500),
	datePicker: Yup.date().required("Select Date").typeError("Invalid input"),
});
let token = null,
	userId = null;
class DeptTicketApproval extends Component {
	constructor(props) {
		super(props);
		this.state = {
			date: new Date().toDateString(),
			DepartmentComments: "",
			cmComments: "",
			ticketDetails: {},
			CMapproval: false,
			datePicker: "",
			forwardTo: null,
			commentsErr: false,
			urgency: "",
			disableChange: false,
			showLoader: true,
			forwardToNameList: [],
		};
	}
	handleChange = (temp, displayCode, event) => {
		if (displayCode === 1) {
			this.setState({
				datePicker: temp,
			});
		} else {
			const value =
				temp.target.type === "checkbox"
					? temp.target.checked
					: temp.target.value;
			this.setState({
				[temp.target.name]: value,
			});
		}
	};
	handleSubmit = (values) => {
		AlertPopups.confirmBox
			.fire({
				text: `${AlertPopups.acceptTicketConfirm}`,
			})
			.then((result) => {
				if (result.value) {
					let self = this;
					var data = {
						ticketId: parseInt(this.props.match.params.ticketId),
						updateBy: parseInt(userId),
						comment:
							values.DepartmentComments.trim() !== ""
								? values.DepartmentComments
								: null,
						expectedDate:
							values.datePicker !== "" &&
							values.datePicker !== undefined &&
							values.datePicker !== null
								? moment(
										values.datePicker,
										"ddd MMM DD YYYY HH:mm:ss"
								  ).format("YYYY-MM-DDTHH:mm:00.000")
								: this.state.ticketDetails.expectedDate,
						expectedTime:
							values.datePicker !== "" &&
							values.datePicker !== undefined &&
							values.datePicker !== null
								? moment(
										values.datePicker,
										"ddd MMM DD YYYY HH:mm:ss"
								  ).format("YYYY-MM-DDTHH:mm:00.000")
								: this.state.ticketDetails.expectedTime,
						needApproval: this.state.CMapproval,
						status: 1,
					};

					var headers = {
						Authorization: `Bearer ${token}`,
					};
					axios
						.put(
							`${Department_APIs.EditTicketByAssignee_API}`,
							data,
							{
								headers: headers,
							}
						)
						.then(function (response) {
							if (response.status === 200) {
								AlertPopups.successAlert.fire({
									text: `${AlertPopups.acceptTicketMsg}`,
								});

								self.props.history.push(
									Routes.DeptTicketListing
								);
							} else {
								AlertPopups.WarningAlert.fire({
									text: `Try again please`,
								});
							}
						});
				}
			});
	};
	handleClick = (temp) => {
		AlertPopups.confirmBox
			.fire({
				text: `${AlertPopups.confirmMsg}`,
			})
			.then((result) => {
				if (result.value) {
					let self = this;
					var data = {},
						headers = {};
					if (temp === 1) {
						//reject btn functionality here
						data = {
							ticketId: parseInt(
								this.props.match.params.ticketId
							),
							updateBy: parseInt(userId),
							comment:
								this.state.DepartmentComments.trim() !== ""
									? this.state.DepartmentComments
									: null,
							expectedDate:
								this.state.datePicker !== "" &&
								this.state.datePicker !== undefined &&
								this.state.datePicker !== null
									? moment(
											this.state.datePicker,
											"ddd MMM DD YYYY HH:mm:ss"
									  ).format("YYYY-MM-DDTHH:mm:00.000")
									: this.state.ticketDetails.expectedDate,
							expectedTime:
								this.state.datePicker !== "" &&
								this.state.datePicker !== undefined &&
								this.state.datePicker !== null
									? moment(
											this.state.datePicker,
											"ddd MMM DD YYYY HH:mm:ss"
									  ).format("YYYY-MM-DDTHH:mm:00.000")
									: this.state.ticketDetails.expectedTime,
							needApproval: false,
							status: 3,
						};
						headers = {
							Authorization: `Bearer ${token}`,
						};
						axios
							.put(
								`${Department_APIs.EditTicketByAssignee_API}`,
								data,
								{
									headers: headers,
								}
							)
							.then(function (response) {
								if (response.status === 200) {
									AlertPopups.successAlert.fire({
										text: `${AlertPopups.rejectTicketMsg}`,
									});
									let history = self.props.history;
									history.push({
										pathname:
											history.location.state.redirectUrl,
										state: {
											currentPage:
												history.location.state
													.currentPage,
										},
									});
								}
							})
							.catch((error) => {
								AlertPopups.WarningAlert.fire({
									text: `Try again please`,
								});
							});
					}

					if (temp === 2) {
						if (this.state.ticketDetails.status === 1) {
							data = {
								ticketId: parseInt(
									this.props.match.params.ticketId
								),
								updateBy: parseInt(userId),
								comment: this.state.DepartmentComments,
								expectedDate:
									this.state.datePicker.toString() !== ""
										? moment(
												this.state.datePicker,
												"ddd MMM DD YYYY HH:mm:ss"
										  ).format("YYYY-MM-DDTHH:mm:00.000")
										: this.state.ticketDetails.expectedDate,
								expectedTime:
									this.state.datePicker.toString() !== ""
										? moment(
												this.state.datePicker,
												"ddd MMM DD YYYY HH:mm:ss"
										  ).format("YYYY-MM-DDTHH:mm:00.000")
										: this.state.ticketDetails.expectedTime,
								needApproval: false,
								status: 2,
							};
							headers = {
								Authorization: `Bearer ${token}`,
							};
							axios
								.put(
									`${Department_APIs.EditTicketByAssignee_API}`,
									data,
									{
										headers: headers,
									}
								)
								.then(function (response) {
									if (response.status === 200) {
										AlertPopups.successAlert.fire({
											text: `${AlertPopups.completeMsg}`,
										});
										self.props.history.push(
											Routes.DeptTicketListing
										);
									}
								})
								.catch((error) => {
									AlertPopups.WarningAlert.fire({
										text: `Try again please`,
									});
								});
						}
					}
				}
			});
	};
	openDatepicker = () => this._calendar.setOpen(true);
	componentDidMount() {
		var headers = {
			Authorization: `Bearer ${token}`,
		};
		axios
			.get(
				`${Resource_APIs.GetTicketForwardToNames}${this.props.location.state?.departmentId}`,
				{
					headers: headers,
				}
			)
			.then((res) => {
				const data = res.data.map((obj) => {
					return { value: obj.employeeId, label: obj.employeeName };
				});

				this.setState(
					{
						forwardToNameList: data.sort((a, b) =>
							a.label.localeCompare(b.label)
						),
					},
					() => {
						axios
							.get(
								`${Resource_APIs.GetTicketDetail_API}${this.props.match.params.ticketId}`,
								{
									headers: headers,
								}
							)
							.then((res) => {
								res.data.comments = this.sortDates(
									res.data.comments
								);
								this.setState({
									showLoader: false,
									ticketDetails: res.data.ticket,
									datePicker: new Date(
										res.data.ticket.expectedTime
									),
									DepartmentComments:
										this.getRecentDeptComment(
											res.data.comments
										),
									cmComments: this.getRecentCMComment(
										res.data.comments
									),
									disableChange:
										res.data.ticket.status !== 0 ||
										(res.data.ticket.approvalDate ===
											null &&
											res.data.ticket.needApproval ===
												true)
											? true
											: false,
								});

								this.setState({
									forwardTo:
										this.state.forwardToNameList.find(
											(item) =>
												item.label ===
												res.data.ticket.assignee
										),
								});
							});
					}
				);
			});
	}
	getRecentDeptComment = (comments) => {
		var deptComment = "";
		if (comments.length !== 0) {
			for (let i = 0; i < comments.length; i++) {
				if (!comments[i].isCMComment)
					deptComment = comments[i].ticketComment;
			}
			return deptComment;
		} else return "";
	};
	getRecentCMComment = (comments) => {
		var cmComment = "";
		if (comments.length !== 0) {
			for (let i = 0; i < comments.length; i++) {
				if (comments[i].isCMComment)
					cmComment = comments[i].ticketComment;
			}
			return cmComment;
		} else return "";
	};
	sortDates = (comments) => {
		let sorted = comments.sort(
			(a, b) =>
				moment(a.commentDate).format("dd/MM/yyyy") -
				moment(b.commentDate).format("dd/MM/yyyy")
		);
		return sorted;
	};
	goBack = () => {
		goBackFunction(Routes.DeptTicketListing, this.props.history);
	};
	ForwardToAPI = (val) => {
		this.setState({
			...this.state,
			forwardTo: val,
		});
		AlertPopups.confirmBox
			.fire({
				text: `${"Are you sure to forward ticket?"}`,
			})
			.then((result) => {
				if (result.value) {
					var headers = {
						Authorization: `Bearer ${token}`,
					};
					const body = {
						ticketId: parseInt(this.props.match.params.ticketId),
						assignTo: this.state.forwardTo.value,
					};
					axios
						.post(`${Resource_APIs.ForwardTicketTo}`, body, {
							headers: headers,
						})
						.then(() => {
							AlertPopups.successAlert.fire({
								text: "Ticket Forwarded",
							});
							this.goBack();
						});
				}
			});
	};
	render() {
		const { ticketDetails } = this.state;
		return (
			<UserConsumer>
				{(userDetails) => {
					token = userDetails.token;
					userId = userDetails.id;
					if (this.state.showLoader) {
						return <PageLoader />;
					} else
						return (
							<div className="container-fluid pl-3 pr-3">
								<FormStatus
									title="Approve or Reject Ticket"
									formStatus={
										this.props.location.state.itemStatus
									}
									className="create-request d-flex align-items-center"
									onClick={this.goBack}
									navigateBack={true}
								/>

								<Formik
									initialValues={this.state}
									enableReinitialize={true}
									onSubmit={(values) =>
										this.handleSubmit(values)
									}
									validationSchema={validation}
									validateOnChange={true}
								>
									{({ errors, handleBlur, handleSubmit }) => (
										<form
											onSubmit={handleSubmit}
											className="itemReqForm"
										>
											<FormGroup
												row
												id="row0"
												className="bottom-spacing topBorders"
											>
												<Label sm={12}>
													Create ID #{" "}
													{
														this.props.match.params
															.ticketId
													}
												</Label>
											</FormGroup>
											<FormGroup
												row
												sm={12}
												className="bottom-spacing rowStyle1"
											>
												<Label sm={3}>Created By</Label>
												<Col sm={3} className="mt-2">
													<span className="dataSpan">
														{ticketDetails.creator}
													</span>
												</Col>
												<Label sm={3}>Ticket For</Label>
												<Col sm={3} className="mt-2">
													<span
														className="dataSpan"
														sm={4}
													>
														{ticketDetails.itemId !==
														null
															? ticketDetails.itemName
															: "Others"}
													</span>
												</Col>
											</FormGroup>
											<FormGroup
												row
												sm={12}
												className="bottom-spacing rowStyle2"
											>
												<Label sm={3}>
													Alternate item
												</Label>
												<Col sm={3} className="mt-2">
													<span className="dataSpan">
														{ticketDetails.alternateTicketItem ===
														null
															? "No alternate item"
															: ticketDetails.alternateTicketItem}
													</span>
												</Col>
												<Label sm={3}>Status</Label>
												<Col sm={3} className="mt-2">
													<span
														className="dataSpan"
														sm={3}
													>
														{ticketDetails.status ===
														0
															? "Pending"
															: ticketDetails.status ===
															  1
															? "InProgress"
															: ticketDetails.status ===
															  2
															? "Completed"
															: "Rejected"}
													</span>
												</Col>
											</FormGroup>
											<FormGroup
												row
												sm={12}
												className="bottom-spacing rowStyle1"
											>
												<Label sm={3}>Assign To</Label>
												<Col sm={3} className="mt-2">
													<span
														sm={3}
														className="dataSpan"
													>
														{
															ticketDetails.department
														}
													</span>
												</Col>
												<Label htmlFor="Person" sm={3}>
													Person
												</Label>
												{ticketDetails.assignee !==
													null &&
												ticketDetails.assignee !==
													"" ? (
													<Col
														sm={3}
														className="mt-2"
													>
														<span
															sm={3}
															className="dataSpan"
														>
															{
																ticketDetails.assignee
															}
														</span>
													</Col>
												) : (
													<Col
														sm={3}
														className="mt-2"
													>
														<span
															sm={3}
															className="dataSpan"
														>
															No assignee person
														</span>
													</Col>
												)}
											</FormGroup>
											<FormGroup
												row
												className="bottom-spacing rowStyle2"
											>
												<Label sm={3}>Priority</Label>
												<Col sm={3} className="mt-2">
													<span
														sm={3}
														className="dataSpan"
													>
														{ticketDetails.priority ===
														0
															? "High"
															: ticketDetails.priority ===
															  1
															? "Medium"
															: "Low"}
													</span>
												</Col>
												<Label sm={3}>
													Due Date & Time
												</Label>
												<Col sm={3} className="mt-2">
													<span className="dataSpan">
														{moment(
															this.state
																.datePicker
														).format(
															"DD/MM/yyyy hh:mm A"
														)}
													</span>
												</Col>
											</FormGroup>

											<FormGroup
												row
												sm={12}
												className="bottom-spacing rowStyle1"
												hidden={
													ticketDetails.attachedFileName ===
														null ||
													ticketDetails.attachedFileName ===
														"" ||
													ticketDetails.attachedFileName ===
														undefined
												}
											>
												<Label
													htmlFor="Attachment"
													sm={3}
												>
													Attachment
												</Label>
												<Col
													sm={9}
													className="mt-2 wordBreak"
												>
													{ticketDetails.attachedFileName !==
														null &&
													ticketDetails.attachedFileName !==
														"" &&
													ticketDetails.attachedFileName !==
														undefined ? (
														<span
															sm={9}
															className="dataSpan"
														>
															<a
																id="imageName"
																href={
																	Config.server_url +
																	ticketDetails.attachedFileName
																}
																target="_blank"
																rel="noopener noreferrer"
																style={{
																	textDecoration:
																		"underline",
																	color: "#43a3a5",
																}}
															>
																{ticketDetails.attachedFileName.slice(
																	20,
																	40
																)}
															</a>
														</span>
													) : (
														<span
															sm={9}
															className="dataSpan"
														>
															No attached file
														</span>
													)}
												</Col>
											</FormGroup>

											<FormGroup
												row
												className="bottom-spacing rowStyle1"
											>
												<Label sm={3}>
													Description
												</Label>
												<Col sm={9} className="mt-2">
													<span className="dataSpan description">
														{ticketDetails.details}
													</span>
												</Col>
											</FormGroup>
											{this.state.cmComments.trim() !==
												"" && (
												<FormGroup
													row
													className="bottom-spacing rowStyle1"
												>
													<Label sm={3}>
														CM Comments
													</Label>
													<Col
														sm={9}
														className="mt-2"
													>
														<span
															sm={9}
															className="dataSpan"
														>
															{
																this.state
																	.cmComments
															}
														</span>
													</Col>
												</FormGroup>
											)}

											<div>
												<FormGroup
													row
													className="bottom-spacing rowStyle2"
												>
													<Label
														for="datePicker"
														sm={3}
													>
														Change Date & Time
													</Label>
													<div
														style={{
															fontWeight:
																"normal",
														}}
														className="col-sm-3"
													>
														<Col className="datepicker-wrapper pl-1 pr-2">
															<DatePicker
																showYearDropdown
																showMonthDropdown
																dateFormatCalendar=" " //for title
																name="datePicker"
																id="datePicker"
																bsSize="sm"
																selected={
																	this.state
																		.datePicker
																}
																autoComplete="off"
																onChange={(
																	value,
																	event
																) =>
																	this.handleChange(
																		value,
																		1,
																		event
																	)
																}
																onChangeRaw={(
																	e
																) => {
																	e.preventDefault();
																}}
																className={
																	errors.datePicker
																		? "px-2 invalid"
																		: "px-2"
																}
																dateFormat="dd/MM/yyyy h:mm a"
																disabledKeyboardNavigation
																showTimeSelect
																minDate={
																	new Date()
																}
																disabled={
																	this.state
																		.disableChange
																}
																ref={(c) =>
																	(this._calendar =
																		c)
																}
															/>

															<FontAwesomeIcon
																icon={
																	faCalendarAlt
																}
																className="calender-icon"
																color="keppel"
																onClick={
																	this
																		.openDatepicker
																}
															/>
														</Col>
													</div>
													<Label
														for="datePicker"
														sm={3}
													>
														Forward To
													</Label>
													<div
														style={{
															fontWeight:
																"normal",
														}}
														className="col-sm-3"
													>
														<Col>
															<CustomReactSelect
																options={
																	this.state
																		.forwardToNameList
																}
																name="assignee"
																id="assignee"
																bsSize="sm"
																styles={
																	Ticket_Variables.react_select_style
																}
																onChange={(
																	val
																) =>
																	this.ForwardToAPI(
																		val
																	)
																}
																readOnly={
																	this.state
																		.disableChange
																}
																isDisabled={
																	this.state
																		.ticketDetails
																		.status ===
																	3
																}
																value={
																	this.state
																		.forwardTo
																}
															/>
														</Col>
													</div>
												</FormGroup>

												<FormGroup
													row
													className={`bottom-spacing rowStyle1 ${
														this.state
															.disableChange &&
														"lastRow"
													}`}
												>
													<Label sm={3}>
														Department Comments
													</Label>
													<Col sm={9}>
														<Input
															type="textarea"
															name="DepartmentComments"
															id="DepartmentComments"
															onChange={(
																value,
																event
															) =>
																this.handleChange(
																	value,
																	2,
																	event
																)
															}
															className={`h-auto ${
																errors.DepartmentComments
																	? "invalid"
																	: ""
															}`}
															value={
																this.state
																	.DepartmentComments
															}
															onBlur={handleBlur}
															disabled={
																this.state
																	.disableChange
															}
															maxLength="500"
														/>
													</Col>
												</FormGroup>
												<FormGroup
													row
													className="bottom-spacing rowStyle2"
													hidden={
														this.state.disableChange
													}
												>
													<Label sm={3}>
														{" "}
														Needs CM Approval
													</Label>
													<Col sm={1}>
														<Input
															className="checkboxInput"
															type="checkbox"
															name="CMapproval"
															id="CMapproval"
															onChange={(
																value,
																event
															) =>
																this.handleChange(
																	value,
																	3,
																	event
																)
															}
															style={{
																height: "auto",
															}}
															value={
																this.state
																	.CMapproval
															}
															disabled={
																this.state
																	.disableChange
															}
														/>
													</Col>
												</FormGroup>
												<div className="btns mt-3">
													<Button
														className="approve-btn"
														type="Submit"
														hidden={
															this.state
																.disableChange
														}
													>
														Accpet
													</Button>
													<Button
														type="button"
														id="rejectBtn"
														className="delete-btn ml-2"
														onClick={() =>
															this.handleClick(1)
														}
														hidden={
															this.state
																.disableChange
														}
													>
														Reject
													</Button>
													<Button
														type="button"
														className="approve-btn"
														id="completeBtn"
														onClick={() => {
															this.handleClick(2);
														}}
														hidden={
															ticketDetails.status !==
																1 ||
															(ticketDetails.approvalDate ===
																null &&
																ticketDetails.needApproval ===
																	true)
														}
													>
														Complete
													</Button>
												</div>
											</div>
										</form>
									)}
								</Formik>
							</div>
						);
				}}
			</UserConsumer>
		);
	}
}
export default DeptTicketApproval;
